import { ClusterProvider, useUser } from '@myosh/myosh-login'
import { Navigate, Outlet } from 'react-router'

function PrivateLayoutRoute() {
  const { state } = useUser()
  const { auth: isAuthenticated, loginStatus } = state

  return isAuthenticated && loginStatus === 'done' ? (
    <ClusterProvider>
      <Outlet />
    </ClusterProvider>
  ) : (
    <Navigate to='/login' />
  )
}

export default PrivateLayoutRoute
